/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from "react";

import "./BackgroundLoader.scss";
import usePrevValue from "hooks/usePrevValue";

type BackgorundLoaderProps = {
  show: boolean;
};

function BackgroundLoader(props: BackgorundLoaderProps) {
  const { show } = props;
  const prevShowValue = usePrevValue(show);
  const [exitClass, setExitClass] = useState("");

  useEffect(() => {
    if (!show && prevShowValue) {
      setExitClass("exit");
    }
  }, [show, prevShowValue]);

  return (
    <div className={`bg-loader-container ${show ? "enter" : exitClass} hide-during-print`}>
      <div className="spinner-border spinner-border-sm" role="status" />
      <div className="ml-2">Updating...</div>
    </div>
  );
}

export default React.memo(BackgroundLoader);
